import {
  type SelectArrayInputProps,
  SelectArrayInput,
  useGetList,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const DeviceTypeArrayInput = ({
  source,
}: Pick<SelectArrayInputProps, "source" | "alwaysOn">) => {
  const { isPending, isLoading, data } = useGetList(MODULE_NAMES.DEVICE_TYPES);

  return (
    <SelectArrayInput
      isPending={isPending}
      isLoading={isLoading}
      source={source}
      optionValue="id"
      choices={data ?? []}
    />
  );
};
